module.exports = __webpack_public_path__ + "img/2012-08-18 09.15.19.3e46af89.jpg";